import { COLLECTION_SITES_PAGE } from "./constants";
import { REGISTER_PAGE } from "./constants";

export const collectionDayOne = "28/10/2022";
export const collectionDayTwo = "29/10/2022";

export const pagesToRedirect = [REGISTER_PAGE, COLLECTION_SITES_PAGE];
